import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { getTabsContainerStyle } from "../../..";
import ConversationRespondPanel from "./conversation-respond-panel/ConversationRespondPanel";
import ConversationReviewPanel from "./conversation-review-panel/ConversationReviewPanel";
import ConversationEscalationReviewPanel from "./conversation-escalation-review-panel/ConversationEscalationReviewPanel";
import ConversationDetailedReviewPanel from "./conversation-detailed-review-panel/ConversationDetailedReviewPanel";
import { ThemeProvider } from "@mui/material/styles";
import { useExpertProfileContext } from "../../../../expert";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
const PANEL_MAPPING = {
  respond: ConversationRespondPanel,
  review: ConversationReviewPanel,
  reviewEscalation: ConversationEscalationReviewPanel,
  reviewDetailed: ConversationDetailedReviewPanel
};
const useStyles = makeStyles(theme => ({
  tabsContainer: getTabsContainerStyle(theme)
}));
const ConversationPanel = ({
  message,
  messageResources,
  panelMap
}) => {
  const Panel = {
    ...PANEL_MAPPING,
    ...panelMap
  }[message.conversationState.type];
  const classes = useStyles();
  const {
    isDarkMode
  } = useExpertProfileContext();
  const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tabsContainer
  }, /*#__PURE__*/React.createElement(Panel, {
    message: message,
    messageResources: messageResources
  })));
};
export default ConversationPanel;
ConversationPanel.propTypes = {
  message: PropTypes.object.isRequired,
  messageResources: PropTypes.object.isRequired,
  panelMap: PropTypes.object
};
ConversationPanel.defaultProps = {
  panelMap: {}
};